import { Heart, Sparkles, Shield } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

const NewClientSection = () => {
  const { language } = useLanguage();

  return (
    <section className="py-16 bg-gradient-to-b from-amber-50 to-background" data-testid="new-client-section">
      <div className="max-w-4xl mx-auto px-4">
        <div className="bg-white rounded-2xl shadow-lg border border-amber-100 p-8 md:p-10 text-center">
          {/* Icon */}
          <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-100 rounded-full mb-6">
            <Heart className="w-8 h-8 text-amber-600" />
          </div>

          {/* Heading */}
          <h2 
            className="text-2xl md:text-3xl text-gray-900 mb-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            {language === "fr" 
              ? "Première fois avec Botox ou les fillers?" 
              : "First Time Getting Botox or Fillers?"}
          </h2>

          {/* Description */}
          <p className="text-gray-600 text-lg mb-8 max-w-2xl mx-auto">
            {language === "fr"
              ? "Nous nous spécialisons dans les traitements naturels et conservateurs pour les nouveaux clients. Votre confort et votre sécurité sont notre priorité absolue."
              : "We specialize in natural, conservative treatments for first-time clients. Your comfort and safety are our top priority."}
          </p>

          {/* Trust Points */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="flex flex-col items-center p-4">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mb-3">
                <Shield className="w-6 h-6 text-green-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-1">
                {language === "fr" ? "Approche Sécuritaire" : "Safety-First Approach"}
              </h3>
              <p className="text-sm text-gray-500">
                {language === "fr" ? "35+ ans d'expérience clinique" : "35+ years clinical experience"}
              </p>
            </div>

            <div className="flex flex-col items-center p-4">
              <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center mb-3">
                <Sparkles className="w-6 h-6 text-amber-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-1">
                {language === "fr" ? "Résultats Naturels" : "Natural Results"}
              </h3>
              <p className="text-sm text-gray-500">
                {language === "fr" ? "Améliorations subtiles et raffinées" : "Subtle, refined enhancements"}
              </p>
            </div>

            <div className="flex flex-col items-center p-4">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-3">
                <Heart className="w-6 h-6 text-blue-600" />
              </div>
              <h3 className="font-semibold text-gray-900 mb-1">
                {language === "fr" ? "Consultation Gratuite" : "Free Consultation"}
              </h3>
              <p className="text-sm text-gray-500">
                {language === "fr" ? "Discutons de vos objectifs" : "Let's discuss your goals"}
              </p>
            </div>
          </div>

          {/* Reassurance Text */}
          <p className="text-sm text-gray-500 italic">
            {language === "fr"
              ? "\"J'adore aider mes nouveaux clients à se sentir à l'aise. Nous commençons toujours de manière conservatrice - vous pouvez toujours en ajouter plus tard!\" - Karine"
              : "\"I love helping first-time clients feel comfortable. We always start conservative - you can always add more later!\" - Karine"}
          </p>
        </div>
      </div>
    </section>
  );
};

export default NewClientSection;
